import { Component, OnInit, ViewContainerRef, ViewChild } from '@angular/core';
import { CapacityModelService } from "./../services/CapacityModel-Service";
import { ResponseMsg } from "./../common/response-message";
import { ActivatedRoute, Router } from "@angular/router";
import { ValidateDataService } from "./../services/validate-data.service";
import { UploadRequestModel, UploadResponseModel } from "./../models/cm-model";
import { AuthHelper } from './../services/authHelper';
import {
  SohoModalDialogService, SohoBusyIndicatorDirective,
  SohoMessageRef, SohoNotificationService, SohoFileUploadComponent
} from "ids-enterprise-ng";
import { DatePipe } from '@angular/common';
import { UserData } from '../shared/models/user.model';

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.css'],
  providers: [DatePipe]
})
export class UploadComponent implements OnInit {
  selectedFiles!: FileList;
  dialog!: SohoMessageRef;
  @ViewChild(SohoBusyIndicatorDirective, { static: true }) busyIndicator?: SohoBusyIndicatorDirective;
  @ViewChild(SohoFileUploadComponent, { static: true }) fileupload?: SohoFileUploadComponent;
  placeholder!: ViewContainerRef;
  uniqueID: string = "0";

  isvalid!: boolean;
  public getTodaysDate!: Date;
  public getDate?: string;
  emailAddress!: string;
  userData = new UserData();
  message = 'Uploading...';
  delay = 5;
  transparentOverlay = false;

  public ObjResponse: any;

  public UploadTypeToolTip = ResponseMsg.UploadTypeToolTip;
  public ProjectTitle = "Upload";

  constructor(private capacityModelService: CapacityModelService,
    private validateService: ValidateDataService,
    public model: UploadRequestModel,
    public responsemodel: UploadResponseModel,
    private modalDialog: SohoModalDialogService,
    private router: Router,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private authhelper: AuthHelper,
    private notificationService: SohoNotificationService) { }

  ngOnInit(): void {
    Soho.Locale.set('en-US');
    this.showNotification();
    this.userData = JSON.parse(localStorage.getItem("userprofile")!);
    if (this.userData != null && this.userData != undefined) {
      this.emailAddress = this.userData.Email;
    }
  }
  showNotification() {
    this.notificationService.show({
      parent: "#notification",
      message:
        "This page is used to upload data.",
      type: "info",
      linkText: "",
      link: "",
    });
    this.getTodaysDate = new Date();
    this.getDate = this.datePipe.transform(new Date(), 'MM/dd/yyyy')!;
    //$("#btnBusy").trigger('click');
  }
  start() {
    (this.busyIndicator as any).activated = true;
  }

  stop() {
    (this.busyIndicator as any).activated = false;
  }
  LoadBusyIndicator() {
    (this.busyIndicator as any).activated = true;
    setTimeout((_f: any) => (this.busyIndicator as any).activated = false, 20000);
  }
  CloseBusyIndicator() {
    (this.busyIndicator as any).activated = false;
  }
  RemoveError(id: string) {
    $("#" + id).removeMessage().removeError();
  }
  ShowErrorAlert(Message: string, Title: string) {
    const dialogRef1 = this.modalDialog
      .message("<h2>" + Message + "</h2>")
      .buttons(
        [
          {
            text: 'Ok', click: () => {
              dialogRef1.close('Ok');
            }, isDefault: true
          }
        ])
      .title(Title)
      .open()
      .frameHeight(1000);
  }

  ShowAlert(Message: string, Title: string) {
    const dialogRef1 = this.modalDialog
      .message("<h2>" + Message + "</h2>")
      .buttons(
        [
          {
            text: 'Ok', click: () => {
              dialogRef1.close('Ok');
              this.ResetModel();
            }, isDefault: true
          }
        ])
      .title(Title)
      .open()
      .frameHeight(1000);
  }
  ResetModel() {
    let fields: string[] = [
      "FiscalYear",
      "UploadTypeID"
    ];
    for (let objField of fields) {
      $("#" + objField).removeError();
    }
    this.fileupload?.clearUploadFile();
    this.model.filename = "";
    this.model.contenttype = "";
    this.model.fiscalyear = '';
    this.model.method = "";
    this.model.uploadtypeid = 0;
    this.model.userlogin = "";
  }

  UploadFile() {

    this.model.userlogin = this.emailAddress == null ? "rameshbabu.kollu@infor.com" : this.emailAddress;
    //console.log(this.model.userlogin);
    this.isvalid = true;

    let errorFields: string[];
    errorFields = [];
    errorFields = this.validateService.validateFormFields(this.model, ["FiscalYear", "UploadTypeID"]);

    if (errorFields.length > 0) {
      for (let objField of errorFields) {
        $("#" + objField)
          .removeError()
          .addError({ message: ResponseMsg.Required, showTooltip: true });
        this.isvalid = false;
      }
    }
    if (this.selectedFiles == undefined) {
      this.ShowErrorAlert("Please select file to upload.", "Error");
      this.isvalid = false;
    }
    else if (this.selectedFiles.length <= 0) {
      this.ShowErrorAlert("Please select file to upload.", "Error");
      this.isvalid = false;
    }
    if (this.isvalid) {
      this.start();
      const file = this.selectedFiles.item(0);

      this.capacityModelService.GetS3PresignedURL(this.model).subscribe(
        response => {
          if (response.status == 200) {
            this.responsemodel = response.body;
            if (file != null) {
              this.responsemodel.FileToUpload = file;
            }
            this.capacityModelService.PostUploadFile(this.responsemodel).subscribe(
              data => {
                this.ShowAlert("File uploaded succesfully", ResponseMsg.Success);
                this.stop();
              }
            );
          }
          else {
            this.ShowAlert("Error occured", ResponseMsg.ErrorMsg);
            this.stop();
          }
        },
        (error: Response) => {
          this.ShowAlert(ResponseMsg.ErrUploadFile, ResponseMsg.ErrorMsg);
          this.CloseBusyIndicator();
          this.stop();
        }
      );
    }
  }
  AddErrorDetails(error: Response) {
    // this.appError.Ok = error.ok;
    // this.appError.Status = error.status;
    // this.appError.StatusText = error.statusText;
    // this.appError.URL = error.url;
    // this.appError.Body = error.json()["ExceptionMessage"];
    // this.projectService.LogErrorDetails(this.appError).subscribe(success => {
    //   console.log("Error details");
    // });
  }
  SetFile(event: any) {
    this.selectedFiles = event.target.files;
  }
}
